import type { Attachment } from 'svelte/attachments';

/**
 * Marks a scroll container with `data-more-above` / `data-more-below` while
 * there is hidden content in that direction, so CSS can fade the edge and make
 * it obvious the list scrolls.
 *
 *   <ul class="list" {@attach scrollFade}>
 */
export const scrollFade: Attachment<HTMLElement> = (node) => {
  const update = () => {
    const { scrollTop, scrollHeight, clientHeight } = node;
    node.toggleAttribute('data-more-above', scrollTop > 1);
    node.toggleAttribute(
      'data-more-below',
      scrollTop + clientHeight < scrollHeight - 1
    );
  };

  /* Re-check when the box resizes or its children change (search results,
     "load more", removed variations). */
  const resizeObserver = new ResizeObserver(update);
  resizeObserver.observe(node);
  const mutationObserver = new MutationObserver(update);
  mutationObserver.observe(node, { childList: true, subtree: true });
  node.addEventListener('scroll', update, { passive: true });
  update();

  return () => {
    resizeObserver.disconnect();
    mutationObserver.disconnect();
    node.removeEventListener('scroll', update);
  };
};
